// Tournament constants reused across the admin.

import { STAGED_FORMAT } from '../../../lib/stages';

export const FORMAT_LABELS = {
  staged: 'Stages',
  leaderboard: 'Leaderboard',
  bracket: 'Bracket',
  'bracket-external': 'Bracket (external)',
  external: 'External',
  team: 'Team',
  'team-cumulative': 'Team (cumulative)',
  guess: 'Guessing game',
  mapping: 'Mapping contest',
  'groups-final': 'Two-stage points (groups → final)',
  'rules-only': 'Rules only',
};

export { DEFAULT_POINTS_TABLE } from '../../../lib/stages';

export const DEFAULT_STAGE1_CONFIG = { groupCount: 2, groupSize: 8, advanceTopN: 4 };

// Every tournament that doesn't use stages is legacy: read-only in the admin.
export const isLegacyTournament = (tournament) => (tournament?.format || '') !== STAGED_FORMAT;
